import axios from "axios";

const api = axios.create({
  baseURL: "https://skishore.in/api",
  timeout: 15000, // ⏱ prevent mobile timeout issues
});

// 🔐 Attach token (handles both token keys)
api.interceptors.request.use(
  (config) => {
    const token =
      localStorage.getItem("token") ||
      localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    config.headers.Accept = "application/json";
    return config;
  },
  (error) => Promise.reject(error)
);

// ❗ Global error handler
const handleError = (error) => {
  if (error.response) {
    console.error("API Error:", error.response.data);
    throw new Error(
      error.response.data.message || "Server Error"
    );
  } else if (error.request) {
    throw new Error("No response from server. Check internet.");
  } else {
    throw new Error("Unexpected error occurred");
  }
};

// 📦 USER APIs
export const getUsers = async () => {
  try {
    const res = await api.get("users");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};
export const getActiveServicesBySubcategory = async (subcategoryId) => {
  try {
    const res = await api.get(`services/active/${subcategoryId}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};


export const getUserById = async (id) => {
  try {
    const res = await api.get(`users/${id}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};
 

export const getAllBanners = async () => {
  try {
    const res = await api.get("banners");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const createUser = async (data) => {
  try {
    const res = await api.post("register", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};
export const createForm = async (data) => {
  try {
    const res = await api.post("service-form", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};


export const login = async (data) => {
  try {
    const res = await api.post("login", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const glogin = async (data) => {
  try {
    const res = await api.post("glogin", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateUser = async (id, data) => {
  try {
    const res = await api.put(`users/${id}`, data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteUser = async (id) => {
  try {
    const res = await api.delete(`users/${id}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

// 🗂️ CATEGORY APIs
export const getCategories = async () => {
  try {
    const res = await api.get("categories");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};
export const getMostservies = async () => {
  try {
    const res = await api.get("catelog/products/1");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};
export const getNestedCategories = async () => {
  try {
    const res = await api.get("categories/nested");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const createCategory = async (data) => {
  try {
    const res = await api.post("categories", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateCategory = async (id, data) => {
  try {
    const res = await api.post(`categories/${id}`, data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteCategory = async (id) => {
  try {
    const res = await api.delete(`categories/${id}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

// 🪜 SUBCATEGORY APIs
export const getSubcategories = async () => {
  try {
    const res = await api.get("subcategories");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const createSubcategory = async (data) => {
  try {
    const res = await api.post("subcategories", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateSubcategory = async (id, data) => {
  try {
    const res = await api.post(`subcategories/${id}`, data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteSubcategory = async (id) => {
  try {
    const res = await api.delete(`subcategories/${id}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

// 🔠 TYPE APIs
export const getTypes = async () => {
  try {
    const res = await api.get("types");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const createType = async (data) => {
  try {
    const res = await api.post("types", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateType = async (id, data) => {
  try {
    const res = await api.post(`types/${id}`, data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteType = async (id) => {
  try {
    const res = await api.delete(`types/${id}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

// 🛠️ SERVICE APIs
export const getServices = async () => {
  try {
    const res = await api.get("services");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const createService = async (data) => {
  try {
    const res = await api.post("services", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateService = async (id, data) => {
  try {
    const res = await api.post(`services/${id}`, data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteService = async (id) => {
  try {
    const res = await api.delete(`services/${id}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

// ⏰ TIMESLOT APIs
export const getTimeSlots = async () => {
  try {
    const res = await api.get("timeslots");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const createTimeSlot = async (data) => {
  try {
    const res = await api.post("timeslots", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const updateTimeSlot = async (id, data) => {
  try {
    const res = await api.put(`timeslots/${id}`, data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteTimeSlot = async (id) => {
  try {
    const res = await api.delete(`timeslots/${id}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

// 📦 ORDER APIs
export const getOrders = async () => {
  try {
    const res = await api.get("orders");
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const createOrder = async (data) => {
  try {
    const res = await api.post("orders", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const verifyPayment = async (txnid,status) => {
  try {
    const res = await api.post(`verify-payment?txnid=${txnid}&status=${status}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const getOrdersByUser = async (userId) => {
  try {
    const res = await api.get(`orders/user/${userId}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};
export const updateOrder = async (id, data) => {
  try {
    const res = await api.put(`orders/${id}`, data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export const deleteOrder = async (id) => {
  try {
    const res = await api.delete(`orders/${id}`);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};

export default api;
